import CardModal from '@/views/components/CardModal';
export default {
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    CardModal,
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    visible: Boolean,
    cb_f: null,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    style () {
      return {
        width: this.width,
        height: this.height,
        margin: '0 auto',
      };
    },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    close () {
      this.$refs.modal.remove();
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
